import AppRecord from './AppRecord.js'
import APP from 'src/main.js'

class FeeRate extends AppRecord {
  resetMomerizedComputed(){
    this._entity_long_name = undefined
  }
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get entity_long_name(){
    if(this._entity_long_name){return this._entity_long_name}
    if(this.entity){return this._entity_long_name = this.entity.long_name}
    return undefined
  }
}

export default FeeRate
